import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import notaDeCreditoVentaRPdfV2 from "./PdfV2.0/notaDeCreditoVentaRPdfV2";

moment.locale("es");
const notaDeCreditoVentaRPdf = (values) => {
  const empresa = values.respuestaFactura.empresa;
  if (empresa.tipoPDF === "moderno") return notaDeCreditoVentaRPdfV2(values);
  const dataSat = values.respuestaFactura.dataSat;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const decimalesTipoCambioPdf = Number.isFinite(Number(empresa?.decimalesTipoCambioPdf)) ? Number(empresa.decimalesTipoCambioPdf) : 4;
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  let cartaPorte


  if (dataSat?.Complemento?.Any.find(item => item['cartaporte31:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte31:CartaPorte'])['cartaporte31:CartaPorte']
  }

  if (dataSat?.Complemento?.Any.find(item => item['cartaporte30:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte30:CartaPorte'])['cartaporte30:CartaPorte']
  }


  const conceptos = dataSat.Conceptos.map((valueConcepto) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });
    return [
      { style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" },
      {
        text: valueConcepto.ClaveUnidad,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.ClaveProdServ,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.NoIdentificacion,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      {
        text: dineroDisabledMask(iva),
        style: "textoTablaChico",
        alignment: "right",
      },
      ...(empresa.imprimirIEPS
        ? [
            {
              text: dineroDisabledMask(ieps),
              style: "textoTablaChico",
              alignment: "right",
            },
          ]
      : []),
      {
        text: dineroDisabledMask(valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf),
        style: "textoTablaChico",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(valueConcepto.Importe),
        style: "textoTablaChico",
        alignment: "right",
      },
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados) ?
    [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"]
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }

      let border = indexImpuesto + 1 === nuevoArrayImpFLOdenado.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones) ?
    [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"]
      }

      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  )

  const totalImpFL = dataSat.Impuestos.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeTraslados"] || 0) || 0
  const totalRetFL = dataSat.Impuestos.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeRetenciones"] || 0) || 0

  let cancelado = {}
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
  }
  let observaciones = {}
  if (values.imprimirObservaciones && values.observaciones) {
    observaciones = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, false],
              text: "Observaciones:",
              margin: [0, 0, 0, 5],
              style: "header",
            },
          ],
          [
            {
              border: [true, false, true, true],
              text: values.observaciones,
              margin: [0, 0, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
          defaultBorder: false,
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
    };
  }



  //Datos carta porte

  let ubicaciones = []

  if (cartaPorte?.Ubicaciones) {
    for (const ubicacion of cartaPorte.Ubicaciones) {
      ubicaciones.push(
        [
          {
            style: 'textoTablaChico',
            text: ubicacion.TipoUbicacion + ' - ' + ubicacion.IDUbicacion,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.RFCRemitenteDestinatario,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.NombreRemitenteDestinatario,
            alignment: 'lefth'
          },
          {
            text: 'MXN',
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: '-', style: 'textoTablaChico', alignment: 'center' },
          { text: ubicacion.FechaHoraSalidaLlegada, style: 'textoTablaChico', alignment: 'center' },
        ],
        [
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'lefth' },
          { style: 'textoTablaChico', text: (ubicacion.Domicilio.Calle ? ubicacion.Domicilio.Calle : '') + (ubicacion.Domicilio.NumeroExterior ? (' #' + ubicacion.Domicilio.NumeroExterior) : '') + (ubicacion.Domicilio.NumeroInterior ? (' - ' + ubicacion.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacion.Domicilio.ColoniaNombre + ' CP: ' + ubicacion.Domicilio.CodigoPostal + (ubicacion.Domicilio.Referencia ? (' Referencia: ' + ubicacion.Domicilio.Referencia) : '') + ' - ' + (ubicacion.Domicilio.MunicipioNombre ? ubicacion.Domicilio.MunicipioNombre : '') + ' ' + ubicacion.Domicilio.Estado + ' ' + ubicacion.Domicilio.Pais, alignment: 'lefth', colSpan: 5 },
          {},
          {},
          {},
          {},
        ]
      )
    }
  }


  let figuras = []

  if (cartaPorte?.FiguraTransporte) {
    for (const figura of cartaPorte.FiguraTransporte) {
      let tipoFiguraTexto

      if (figura.TipoFigura === '01') {
        tipoFiguraTexto = "Operador"
      } else if (figura.TipoFigura === '02') {
        tipoFiguraTexto = "Propietario"
      } else if (figura.TipoFigura === '03') {
        tipoFiguraTexto = "Arrendador"
      } else if (figura.TipoFigura === '04') {
        tipoFiguraTexto = "Notificado"
      }

      const filaDomicilioFigura = figura?.Domicilio && Object.keys(figura.Domicilio).length > 0
        ? [
          [
            { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'left' },
            {
              style: 'textoTablaChico',
              text:
                (figura.Domicilio.Calle ? figura.Domicilio.Calle : '') +
                (figura.Domicilio.NumeroExterior ? ` #${figura.Domicilio.NumeroExterior}` : '') +
                (figura.Domicilio.NumeroInterior ? ` - ${figura.Domicilio.NumeroInterior}` : '') +
                (figura.Domicilio.ColoniaNombre ? ` Col: ${figura.Domicilio.ColoniaNombre}` : '') +
                (figura.Domicilio.CodigoPostal ? ` CP: ${figura.Domicilio.CodigoPostal}` : '') +
                (figura.Domicilio.Referencia ? ` Referencia: ${figura.Domicilio.Referencia}` : '') +
                (figura.Domicilio.MunicipioNombre ? ` - ${figura.Domicilio.MunicipioNombre}` : '') +
                (figura.Domicilio.Estado ? ` ${figura.Domicilio.Estado}` : '') +
                (figura.Domicilio.Pais ? ` ${figura.Domicilio.Pais}` : ''),
              alignment: 'left',
              colSpan: 5
            },
            {},
            {},
            {},
            {}
          ]
        ]
        : [];

      figuras.push(
        [
          {
            style: 'textoTablaChico',
            text: figura.TipoFigura + ' - ' + tipoFiguraTexto,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.RFCFigura,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.NombreFigura,
            alignment: 'lefth'
          },
          {
            text: figura.NumLicencia,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: figura.ResidenciaFiscalFigura ? figura.ResidenciaFiscalFigura : '-', style: 'textoTablaChico', alignment: 'center' },
          { text: figura.NumRegIdTribFigura ? figura.NumRegIdTribFigura : '-', style: 'textoTablaChico', alignment: 'center' },
        ],
        ...filaDomicilioFigura
      )
    }
  }


  let mercancias = []

  if (cartaPorte?.Mercancias?.Mercancia) {


    for (const mercancia of cartaPorte.Mercancias.Mercancia) {

      let agregarFinalMercancias = []
      let cantidadTotal = 0

      if (mercancia.CantidadTransporta) {
        for (const cantidad of mercancia.CantidadTransporta) {

          cantidadTotal += cantidad.Cantidad

          const ubicacionOrigen = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDOrigen)
          const ubicacionDestino = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDDestino)


          agregarFinalMercancias.push(
            [
              { style: 'textoTablaChico', text: cantidad.Cantidad, alignment: 'right' },
              { style: 'textoTablaChico', text: 'Origen: ' + ubicacionOrigen.IDUbicacion + ' - ' + (ubicacionOrigen.Domicilio.Calle ? ubicacionOrigen.Domicilio.Calle : '') + (ubicacionOrigen.Domicilio.NumeroExterior ? (' #' + ubicacionOrigen.Domicilio.NumeroExterior) : '') + (ubicacionOrigen.Domicilio.NumeroInterior ? (' - ' + ubicacionOrigen.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionOrigen.Domicilio.ColoniaNombre + ' CP: ' + ubicacionOrigen.Domicilio.CodigoPostal + (ubicacionOrigen.Domicilio.Referencia ? (' Referencia: ' + ubicacionOrigen.Domicilio.Referencia) : '') + ' - ' + (ubicacionOrigen.Domicilio.MunicipioNombre ? ubicacionOrigen.Domicilio.MunicipioNombre : '') + ' ' + ubicacionOrigen.Domicilio.Estado + ' ' + ubicacionOrigen.Domicilio.Pais, alignment: 'lefth', colSpan: 3 },
              {},
              {},
              { style: 'textoTablaChico', text: 'Destino: ' + ubicacionDestino.IDUbicacion + ' - ' + (ubicacionDestino.Domicilio.Calle ? ubicacionDestino.Domicilio.Calle : '') + (ubicacionDestino.Domicilio.NumeroExterior ? (' #' + ubicacionDestino.Domicilio.NumeroExterior) : '') + (ubicacionDestino.Domicilio.NumeroInterior ? (' - ' + ubicacionDestino.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionDestino.Domicilio.ColoniaNombre + ' CP: ' + ubicacionDestino.Domicilio.CodigoPostal + (ubicacionDestino.Domicilio.Referencia ? (' Referencia: ' + ubicacionDestino.Domicilio.Referencia) : '') + ' - ' + (ubicacionDestino.Domicilio.MunicipioNombre ? ubicacionDestino.Domicilio.MunicipioNombre : '') + ' ' + ubicacionDestino.Domicilio.Estado + ' ' + ubicacionDestino.Domicilio.Pais, alignment: 'lefth', colSpan: 4 },
              {},
              {},
              {},
            ]
          )

        }
      }

      mercancias.push(
        [
          { style: 'textoTablaChico', text: cantidadTotal, alignment: 'right' },
          {
            text: mercancia.Unidad,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.BienesTransp + ' - ' + mercancia.Descripcion,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.CveMaterialPeligroso ? mercancia.CveMaterialPeligroso : 'No',
            style: 'textoTablaChico',
            alignment: 'left'
          },
          {
            text: mercancia.Embalaje ? (mercancia.Embalaje + ' - ' + mercancia.DescripEmbalaje) : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PesoEnKg,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.FraccionArancelaria,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PermisoImportacion ? mercancia.PermisoImportacion : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          }
        ],
      )

      if (mercancia.GuiasIdentificacion) {
        for (const guiaIdent of mercancia.GuiasIdentificacion) {
          mercancia.push(
            [
              { text: 'No. de Guia', style: 'tituloTabla', colSpan: 2 },
              {},
              { text: guiaIdent.NumeroGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' },
              { text: 'Descripción Guía', style: 'tituloTabla' },
              { text: guiaIdent.DescripGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
              {},
              { text: 'Peso Guía', style: 'tituloTabla' },
              { text: guiaIdent.PesoGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' }
            ]
          )
        }
      }

      for (const agregarFinalMercancia of agregarFinalMercancias) {
        mercancias.push(agregarFinalMercancia)
      }

    }


  }

  let remolques = []

  if (cartaPorte?.Mercancias?.Autotransporte?.Remolques) {

    let dataRemolques = cartaPorte?.Mercancias?.Autotransporte?.Remolques.map(valueR => [
      {
        text: valueR.SubTipoRem + ' - ' + valueR.DescripcionSubtipo,
        style: 'textoTablaChico',
        alignment: 'center'
      },
      {
        text: valueR.Placa,
        style: 'textoTablaChico',
        alignment: 'center'
      },
    ])



    remolques.push(
      { text: 'Remolques', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['50%', '50%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Subtipo Remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
            ],
            ...dataRemolques,
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
    )
  }


  let agregarCartaPorte = []

  if (cartaPorte) {
    let qrCartaPorte = '';
    if (Array.isArray(cartaPorte?.Ubicaciones) && dataSat?.Fecha && cartaPorte["IdCCP"]) {
      const origen = cartaPorte.Ubicaciones.find(ubi => ubi.TipoUbicacion === 'Origen');
      if (origen) {
        const fechaOrig = formatearFechaSAT(origen.FechaHoraSalidaLlegada);
        const fechaTimb = formatearFechaSAT(dataSat.Fecha);
        qrCartaPorte =
          `https://verificacfdi.facturaelectronica.sat.gob.mx/verificaccp/default.aspx?IdCCP=${cartaPorte["IdCCP"]}&FechaOrig=${fechaOrig}&FechaTimb=${fechaTimb}`;
      }
    }
    // función de formato
    function formatearFechaSAT(fechaISO) {
      try {
        let fechaStr = '';

        // Si es moment()
        if (fechaISO && typeof fechaISO === 'object' && typeof fechaISO.toISOString === 'function' && fechaISO._isAMomentObject) {
          fechaStr = fechaISO.toISOString();
        }
        // Si es Date
        else if (fechaISO instanceof Date) {
          fechaStr = fechaISO.toISOString();
        }
        // Si ya es string
        else if (typeof fechaISO === 'string') {
          fechaStr = fechaISO;
        }
        // Si no es nada válido → vacío
        else {
          return '';
        }

        // Aplicar formato
        return fechaStr.replace('Z', '').split('.')[0];

      } catch {
        return '';
      }
    }
    agregarCartaPorte.push(
      { text: 'Detalle Complemento Carta Porte', style: 'tableHeader' },
      {
        style: "tablaSinMargen",
        table: {
          widths: ["20%", "80%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              (qrCartaPorte ? { qr: qrCartaPorte, alignment: "left", fit: 98 } : { text: 'No se pudo realizar el código QR' }),
              {
                style: 'tableExample',
                table: {
                  widths: ['35%', '35%', '30%'],
                  layout: { defaultBorder: true },
                  body: [
                    [
                      { text: 'Folio transaccion (IDCCP)', style: 'tituloTabla' },
                      { text: 'Transporte Internacional', style: 'tituloTabla' },
                      { text: 'Tipo de transporte', style: 'tituloTabla' },
                    ],
                    [
                      {
                        style: 'textoTablaChico',
                        text: cartaPorte["IdCCP"],
                        alignment: 'center'
                      },
                      {
                        style: 'textoTablaChico',
                        text: cartaPorte["TranspInternac"],
                        alignment: 'center'
                      },
                      {
                        text: '-',
                        style: 'textoTablaChico',
                        alignment: 'center'
                      },
                    ],
                    [
                      { text: 'Via de Transporte', style: 'tituloTabla' },
                      { text: 'País de Orígen o Destino', style: 'tituloTabla' },
                      { text: 'Total distancia recorrida', style: 'tituloTabla' },
                    ],
                    [
                      { text: '-', style: 'textoTablaChico', alignment: 'center' },
                      { text: 'MXN', style: 'textoTablaChico', alignment: 'center' },
                      {
                        text: cartaPorte["TotalDistRec"],
                        style: 'textoTablaChico',
                        alignment: 'right'
                      },
                    ]
                  ]
                },
                layout: {
                  fillColor: (rowIndex, node, columnIndex) => {
                    return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
                  },
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                }
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      { text: 'Detalle de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['30%', '10%', '40%', '10%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Permiso SCT', style: 'tituloTabla' },
              { text: 'No. de permiso SCT', style: 'tituloTabla' },
              { text: 'Configuración Vehicular / Tipo de remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
              { text: 'Año', style: 'tituloTabla' },
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.tipoPermiso.Clave + ' - ' + cartaPorte.Mercancias.Autotransporte.tipoPermiso.Descripcion,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.NumPermisoSCT,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: cartaPorte.Mercancias.Autotransporte.configVehicular.Clave + ' - ' + cartaPorte.Mercancias.Autotransporte.configVehicular.Descripcion, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.PlacaVM, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.AnioModeloVM,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      {
        style: 'tableExample',
        table: {
          widths: ['15%', '15%', '15%', '15%', '15%', '15%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Seguro de Responsabilidad Civil', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Medio Ambiente', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Carga', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Prima Seguro', rowSpan: 2, style: 'tituloTabla' },
            ],
            [
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              {},
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraMedAmbiente,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaMedAmbiente,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraCarga, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaCarga, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PrimaSeguro,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      ...remolques,
      { text: 'Ubicaciones', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },
              { text: 'Fecha de Salida / LLegada', style: 'tituloTabla' },
            ],
            ...ubicaciones
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Figuras de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Licencia', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },

            ],
            ...figuras,

          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Detalle Mercancias', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['7%', '8%', '30%', '10%', '10%', '10%', '10%', '15%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Cantidad', style: 'tituloTabla' },
              { text: 'Unidad', style: 'tituloTabla' },
              { text: 'Clave / Descripcion', style: 'tituloTabla' },
              { text: 'Tipo Material peligroso', style: 'tituloTabla' },
              { text: 'Embalaje', style: 'tituloTabla' },
              { text: 'Peso en Kg', style: 'tituloTabla' },
              { text: 'Fraccion Arancelaria', style: 'tituloTabla' },
              { text: 'Pedimento', style: 'tituloTabla' }
            ],
            ...mercancias
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
    )
  }


  const arraySiHayRetenciones = totalRetFL > 0 ? [
    //   [
    //   {
    //     border: [true, false, false, false],
    //     text: "Retenciones:",
    //     style: "subheader",
    //   },
    //   {
    //     border: [false, false, true, false],
    //     text: dineroDisabledMask(
    //       totalRetFL
    //     ),
    //     style: "textoChico",
    //     alignment: "right",
    //   },
    // ],
    [
      {
        border: [true, false, false, true],
        text: "TOTAL PAGO:",
        style: "header",
        fillColor: "#e8e8e8",
      },
      {
        border: [false, false, true, true],
        text: dineroDisabledMask(dataSat.Total),
        style: "header",
        fillColor: "#e8e8e8",
        alignment: "right",
      },
    ]] : []

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL

  let advansLeyenda = []
  if (dataSat?.Receptor?.advansLeyenda) {
    advansLeyenda = [{
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, true],
              text: dataSat?.Receptor?.advansLeyenda,
              margin: [0, 5, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return "#adaaaa";
        },
        vLineColor: function (i, node) {
          return "#adaaaa";
        },
        hLineStyle: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return null;
          }
          return { dash: { length: 2, space: 1 } };
        },
        vLineStyle: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return null;
          }
          return { dash: { length: 2 } };
        },
      },
    }];
  }

  var dd = {
    ...cancelado,
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen,'egreso',
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],

                  body: [
                    [
                      {
                        text: "N° Nota de Credito:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Moneda:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: dataSat.Moneda,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Tipo de Cambio:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      { text: 'Nota De Credito N° ' + (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio, style: 'tableHeaderIzquierda' },
      {
        style: "tableExample",
        table: {
          widths: ["60%", "40%"],
          layout: {
            defaultBorder: false,
          },

          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del cliente :", style: "subheader" },
                      { text: dataSat.Receptor.Nombre, style: "textoChico" },
                    ],
                    [
                      { text: "R.F.C :", style: "subheader" },
                      { text: dataSat.Receptor.Rfc, style: "textoChico" },
                    ],
                    // [
                    //   { text: "Direccion :", style: "subheader" },
                    //   { text: "Variable", style: "textoChico" },
                    // ],
                    [
                      { text: "Forma de pago :", style: "subheader" },
                      {
                        text:
                          "(" +
                          dataSat.formaDePago.c_FormaPago +
                          ") " +
                          dataSat.formaDePago.descripcion, style: "textoChico"
                      },
                    ],
                    [
                      { text: "Metodo de pago :", style: "subheader" },
                      {
                        text:
                          dataSat.MetodoPago === "PUE"
                            ? "PUE - Pago en una sola exhibición"
                            : "PPD - Pago en parcialidades o diferido",
                        style: "textoChico"
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Fecha:", style: "subheader" },
                      {
                        text: moment(dataSat.Fecha).locale("es").format("LL"),
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Lugar de expedicion:", style: "subheader" },
                      { text: dataSat.LugarExpedicion, style: "textoChico" },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },

      {
        style: "tableExample",
        table: {
          widths: [
            "8%", //Cantidad
            "6%", //Unidad
            "9%",  //Clave SAT
            "9%",  //Clave
            empresa.imprimirIEPS ? "29%" : "37%", //Descripción
            "8%", //IVA
            ...(empresa.imprimirIEPS ? ["8%"] : []), //IEPS
            "10.5%",  //P/U
            "12.5%" //Importe
          ],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { text: "Cantidad", style: "tituloTabla" },
              { text: "Unidad", style: "tituloTabla" },
              { text: "Clave SAT", style: "tituloTabla" },
              { text: "Clave", style: "tituloTabla" },
              { text: "Descripción", style: "tituloTabla" },
              { text: "IVA", style: "tituloTabla" },
              ...(empresa.imprimirIEPS ? [{  text: "IEPS", style: "tituloTabla" }] : []),
              { text: "P/U", style: "tituloTabla" },
              { text: "Importe", style: "tituloTabla" },
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tablaSinMargen",
        table: {
          widths: ["70%", "30%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Cantidad con letra:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: "**( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )**",
                        style: "textoChico",
                        fontSize: 7,
                      },
                    ],
                    [
                      {
                        border: [true, true, false, false],
                        text: "Banco:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: empresa.banco ? empresa.banco : "",
                        style: "textoChico",
                      },
                    ],
                    ...(empresa.swiftCode ? [[
                      {
                        border: [true, false, false, false],
                        text: "Swift Code:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.swiftCode ? empresa.swiftCode : "",
                        style: "textoChico",
                      },
                    ]] : []),
                    ...(empresa.abaCode ? [[
                      {
                        border: [true, false, false, false],
                        text: "ABA Code:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.abaCode ? empresa.abaCode : "",
                        style: "textoChico",
                      },
                    ]] : []),
                    [
                      {
                        border: [true, false, false, false],
                        text: "Cuenta:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.cuentaBanco ? empresa.cuentaBanco : "",
                        style: "textoChico",
                      },
                    ],
                    [
                      {
                        border: [true, false, false, true],
                        text: "Cuenta CLABE:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, true],
                        text: empresa.cuentaClabe ? empresa.cuentaClabe : "",
                        style: "textoChico",
                      },
                    ],
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
              {
                table: {
                  widths: ["50%", "50%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Subtotal:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: dineroDisabledMask(dataSat.SubTotal),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    [
                      {
                        border: [true, false, false, false],
                        text: "Descuento:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: dineroDisabledMask(dataSat.Descuento),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    ...impuestosTotales,
                    [
                      {
                        border: [true, false, false, true],
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                      },
                      {
                        border: [false, false, true, true],
                        text: dineroDisabledMask(total),
                        style: "header",
                        fillColor: "#e8e8e8",
                        alignment: "right",
                      },
                    ],
                    ...retencionesTotales,
                    ...arraySiHayRetenciones,
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      observaciones,
      ...advansLeyenda,
      ...agregarCartaPorte,
    ],
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      textoChicoData: {
        fontSize: 6,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTablaChico: {
        fontSize: 6,
        italics: false,
      },
    },
    pageSize: "LETTER",
  };
  return dd;
};

export default notaDeCreditoVentaRPdf;
